import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLanguage } from './LanguageContext';

const API = process.env.REACT_APP_API_URL || '/api';

const MarketingCopyContext = createContext();

export function MarketingCopyProvider({ children }) {
  const { language } = useLanguage();
  const [overrides, setOverrides] = useState({});
  const [loaded, setLoaded] = useState(false);

  const loadOverrides = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/marketing-copy`);
      const map = {};
      for (const row of res.data) {
        map[`${row.page}|${row.block_key}`] = { en: row.content_en, fr: row.content_fr };
      }
      setOverrides(map);
    } catch (err) {
      // Silently fail — defaults will be used
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    loadOverrides();
  }, [loadOverrides]);

  const mc = useCallback((page, key, fallback) => {
    const override = overrides[`${page}|${key}`];
    if (!override) return fallback;
    const val = language === 'fr' ? override.fr : override.en;
    return val || fallback;
  }, [overrides, language]);

  return (
    <MarketingCopyContext.Provider value={{ mc, loaded, refreshOverrides: loadOverrides }}>
      {children}
    </MarketingCopyContext.Provider>
  );
}

export const useMarketingCopy = () => useContext(MarketingCopyContext);
